@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.wrapper {
  @include transition;
  display: flex;
  flex-direction: column;
  background: var(--default-bg);

  .suggestedActions {
    @include hide-scrollbar;
    display: flex;
    gap: 5px;
    overflow: auto;
    padding: 5px 5px 0 5px;

    .topButton {
      @include transition;
      @include md-sohne;
      border-radius: 32px;
      background: var(--dark-4);
      color: var(--dark-80);
      gap: 2px;
      padding: 6px 8px;
      min-height: 32px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      white-space: nowrap;
      position: relative;

      span {
        padding: 0 2px;
      }

      &:active {
        background: var(--dark-8);
        box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.09) inset;
      }
    }
  }
}

.docEmptyWrapper {
  border: 1px solid var(--light-60);
  background: rgba(0, 0, 0, 0.02);
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.08), 0px 2px 10px 0px rgba(0, 0, 0, 0.06);
}

.container {
  @include hide-scrollbar;
  width: 100%;
  overflow-x: scroll;
  background: var(--default-bg);
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 5px;

  &.noSelection {
    justify-content: space-between;
  }

  .bottomButton {
    @include transition;
    display: inline-flex;
    padding: 6px;
    justify-content: center;
    align-items: center;
    border-radius: 990px;
    color: var(--dark-100);
    min-width: 36px;
    height: 36px;
    font-family: Sohne;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: 0.32px;
    flex-shrink: 0;

    &.disabled {
      opacity: 0.3;
      pointer-events: none;
    }

    svg {
      width: 24px;
      height: 24px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    span {
      padding: 0 4px;
      white-space: nowrap;
    }
  }
}

.separator {
  background-color: var(--dark-4);
  min-width: 1px;
  min-height: 28px;
}
